import JSEncrypt from 'jsencrypt'

export async function encryptPassword(that: any, password: string) {
  const { publicKey, needEncryption } = await that.$ucRestfulProxy({
    url: '/login/options',
    type: 'get',
  }, { mock: false })
  if (needEncryption) {
    const createAt = new Date().getTime()
    return encrypt(JSON.stringify({ password, createAt }), publicKey)
  }
  return password
}

function encrypt(value: string, RSA_PUBLIC_KEY: string) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(RSA_PUBLIC_KEY)
  return encrypt.encrypt(value)
}
